import { Box, Skeleton } from "@mui/material";

import NotificationCardWrapper from "../NotificationCardWrapper";

const NotificationLoading = () => {
  return (
    <NotificationCardWrapper
      firstChild={
        <Skeleton
          sx={{ mr: "8px" }}
          variant='circular'
          width={48}
          height={48}
        />
      }
      seccondChild={
        <Box sx={{ width: "70%" }}>
          <Skeleton width={"90%"} />
          <Skeleton width={"40%"} />
        </Box>
      }
      ThirdChild={<Skeleton variant='rounded' width={48} height={48} />}
    />
  );
};

export default NotificationLoading;
